import { Card, Dropdown, Heading, Icon, css } from '@appd/uik';
import { ActionType, getActionsRegistry } from '..';
import { get } from 'lodash';
import { CSSProperties, useState, useEffect } from 'react';
import { emitter, getGlobals } from './DashboardViewer/globals';
import { useRouter } from 'next/router';

interface ContainerProps {
  id: string;
  title?: string; // Make title optional
  children: React.ReactNode;
  style: CSSProperties;
}

export const DashifyContainer = ({ id, title = '', children, style, ...rest }: ContainerProps) => {
  const router = useRouter();
  const ActionsRegistry = getActionsRegistry(router);
  const containerActions: string[] = [ActionType.EDIT, ActionType.DUPLICATE, ActionType.DELETE];
  const actions = Object.keys(ActionsRegistry).filter(k => containerActions.indexOf(k) !== -1);
  const globals = getGlobals();
  const [editMode, setEditMode] = useState(get(globals, 'editMode', false) as boolean);
  const [widgetEditMode, setWidgetEditMode] = useState(get(globals, 'widgetEditMode', false) as boolean);

  useEffect(() => {
    if (emitter) {
      const handler = (e: any) => {
        const { path, data } = e;
        if (path === '/globals/editMode' && editMode !== data) {
          setEditMode(data);
        }
        if (path === '/globals/widgetEditMode' && widgetEditMode !== data) {
          setWidgetEditMode(data);
        }
      };
      emitter.on('globalsChanged', handler);

      return () => {
        emitter?.off('globalsChanged', handler);
      };
    }
  }, [editMode, widgetEditMode]);

  return (
    <Card.Container className={{ height: '100%', boxSizing: 'border-box', overflowY: 'auto' }} style={style}>
      {(title || editMode) && (
        <div
          className={css({
            alignItems: 'center',
            display: 'flex',
            position: 'relative',
            justifyContent: 'space-between',
          })}
          // Prevent the drag and drop interaction from triggering on `<Layout>`, so the menu can be opened.
          onPointerDown={event => event.preventDefault()}
        >
          {title && <Heading size="SUB_SECTION">{title}</Heading>}
          {editMode && !widgetEditMode && (
            <div className="absolute top-0 right-0 mt-[-4px]">
              <Dropdown
                triggerClassName={css({ pointerEvents: 'initial', '--i': 'NaN' })}
                icon={<Icon.Navigation.MoreHorizontal />}
                kind="TERTIARY"
                onClick={selectedIndex => {}}
                onSelect={selected => {
                  const action = actions?.[selected[0]];
                  ActionsRegistry[action].onClick(id);
                }}
                contentClassName={css({ width: 50 })}
              >
                {actions.map(actionKey => (
                  <Dropdown.Option key={ActionsRegistry[actionKey].label}>
                    {ActionsRegistry[actionKey].label}
                  </Dropdown.Option>
                ))}
              </Dropdown>
            </div>
          )}
        </div>
      )}
      {children}
    </Card.Container>
  );
};
